export default "__VITE_ASSET__36afdf14__"